import './social-network-actions.ajscss';

import { AgentDesktopRouter } from '@agent/agent-interface/agent-desktop-router';
import { IOutgoingMailDeprecatedFacade } from '@agent/core/channel-digit/mail/outgoing-mail-deprecated.service';
import { ISmsDeprecatedService } from '@agent/core/channel-digit/sms/sms-deprecated.service';
import { IAppointmentDeprecatedService } from '@agent/core/contact/appointment-deprecated.service';
import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { IUnitOutgoingCallDeprecatedService } from '@agent/core/phone/outcall/unit-outgoing-call-deprecated.service';
import { IComponentController, IComponentOptions, IPromise, IQService } from 'angular';

import { Customer, DisplayDeprecatedComponent, Option, ProfileService } from '@contact/upgrade';

import { ISocialNetworkFrameService } from '../../services/social-network-frame.service';
import { AgentBookinSocialNetworkInprocessState } from '../../state/agent-booking-social-network-routing.module';
import templateUrl from './social-network-actions.template.html';

const MODULE_NAME = 'socialNetworkActions';

class SocialNetworkActionsCtrl extends DisplayDeprecatedComponent implements IComponentController {
  public name = MODULE_NAME;
  public enableTransfer: boolean = false;
  private responseId: string;

  constructor(
    private readonly $q: IQService,
    private readonly contactDeprecatedService: IContactDeprecatedService,
    private readonly smsDeprecatedService: ISmsDeprecatedService,
    private readonly outgoingMailDeprecatedFacade: IOutgoingMailDeprecatedFacade,
    private readonly appointmentDeprecatedService: IAppointmentDeprecatedService,
    private readonly unitOutgoingCallDeprecatedService: IUnitOutgoingCallDeprecatedService,
    private readonly socialNetworkFrameService: ISocialNetworkFrameService,
    private readonly profileService: ProfileService,
    private readonly router: AgentDesktopRouter
  ) {
    super();
  }

  $onInit() {
    if (
      this.profileService.hasPermission('CSR_SOCIAL_NETWORK_INCOMING::contact:transfer_to_skill') ||
      this.profileService.hasPermission('CSR_SOCIAL_NETWORK_INCOMING::contact:transfer')
    ) {
      this.enableTransfer = true;
    }
  }

  closeSocialNetwork(): void {
    if (this.socialNetworkFrameService.activeSocialNetwork) {
      this.socialNetworkFrameService.closeSocialNetwork(this.socialNetworkFrameService.activeSocialNetwork.customerId);
    }
  }

  showActions(): boolean {
    return !!this.socialNetworkFrameService.activeSocialNetwork;
  }

  transfer(isConference: boolean) {
    this.router.navigateFromLastChild([AgentBookinSocialNetworkInprocessState.forward, isConference]);
  }

  openSMSForm(): void {
    this.contactDeprecatedService.getSelectedContact().then(contact => {
      contact.customerId && this.smsDeprecatedService.openSMSForContact(contact.customerId);
    });
  }

  canOpenUnitMail(): boolean {
    return this.outgoingMailDeprecatedFacade.canOpenOutgoingMail();
  }

  openUnitMail(): void {
    this.contactDeprecatedService.getSelectedContact().then(contact => {
      this.outgoingMailDeprecatedFacade.openOutgoingMailForContactUuid(
        Option.of(contact.customerId).getOrElse(contact.customerId || ''),
        this.responseId
      );
    });
  }

  openAppointmentForm(): void {
    this.contactDeprecatedService.getSelectedContact().then(contact => {
      this.contactDeprecatedService.getCustomer(contact.responseId).then(customer => {
        let firstName: string;
        let lastName: string;
        if (!!customer) {
          firstName = customer.firstname;
          lastName = customer.lastname;
        } else {
          firstName = contact.customerName;
          lastName = '';
        }
        this.appointmentDeprecatedService.openAppointmentForm(contact.responseId, contact.phoneNumber, firstName, lastName, contact.skills);
      });
    });
  }

  canOpenOutcall(): boolean {
    return this.unitOutgoingCallDeprecatedService.canOpenOutcall();
  }

  openOutcall() {
    this.openOutcallAction();
  }

  get outcallRequested(): boolean {
    if (this.unitOutgoingCallDeprecatedService.unitOutgoingCall != null) {
      return this.unitOutgoingCallDeprecatedService.unitOutgoingCall.requested;
    }
    return false;
  }

  private openOutcallAction(): void {
    if (!this.outcallRequested) {
      this.retrieveCustomerCardWithResponseId()
        .then(card => this.unitOutgoingCallDeprecatedService.openUnitOutgoingCallFormFromInteraction(this.responseId, card))
        .then(() => this.unitOutgoingCallDeprecatedService.finishAndClosePauseAndTask());
    }
  }

  private retrieveCustomerCardWithResponseId(): IPromise<Customer> {
    let deferred = this.$q.defer<Customer>();
    this.contactDeprecatedService.getCustomer(this.responseId).then(
      customer => {
        if (customer) {
          deferred.resolve(customer);
        } else {
          deferred.reject();
        }
      },
      () => {
        deferred.reject();
      }
    );
    return deferred.promise;
  }
}

export class SocialNetworkActions implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [
    '$q',
    'contactDeprecatedService',
    'smsDeprecatedService',
    'outgoingMailDeprecatedService',
    'appointmentDeprecatedService',
    'unitOutgoingCallDeprecatedService',
    'socialNetworkFrameService',
    'profileService',
    'agentDesktopRouter',
    SocialNetworkActionsCtrl,
  ];
}

export default MODULE_NAME;
